import TableBuktiPotong from './TableBuktiPotong';

export default TableBuktiPotong;